//import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { apiSlice } from "./index";
import {
    FileMetadataEditRequest,
    FileMetadataEditResponse,
    FileMetadataItem,
    FileMetadataListResult,
    upsertFile,
    upsertFiles,
} from "../features/file/fileSlice";
import { Filter, filterToQueryString } from "../features/filter/filterSlice";

export interface UploadPayload {
    id: string;
    file: File;
    title?: string;
}

export interface UploadResult {
    items: { [key: string]: FileMetadataItem };
    message: string;
    errors: string[];
}

//export const fileApi = createApi({
export const fileApi = apiSlice.injectEndpoints({
    //reducerPath: 'fileApi',
    //baseQuery: fetchBaseQuery({ baseUrl: '/api' }),
    endpoints: (builder) => ({
        fileView: builder.query<FileMetadataEditResponse, string>({
            //query: (id) => `ticket/items-view/${id}?planned_start_after=2024-08-15T12:00:00Z`,
            query: (id) => `file/view/${id}`,
            async onQueryStarted(args, { dispatch, queryFulfilled }) {
                console.log("file query started");
                try {
                    const { data } = await queryFulfilled;
                    console.log("Data Received", data);
                    //dispatch(upsertFiles(data.files));
                    dispatch(upsertFile(data.file));
                } catch (err) {
                    console.log("ho no, error in ticket query");
                }
            },
        }),
        uploadFile: builder.mutation<
            //FileMetadataItem
            UploadResult,
            UploadPayload
        >({
            query: ({ id, file, title }: UploadPayload) => {
                const formData = new FormData();
                //formData.append('log_id', '107');
                ////formData.append('title', title || 'my title');
                formData.append("file", file);
                //if (title) formData.append('title', title);

                return {
                    url: "file/upload/" + id,
                    method: "POST",
                    body: formData,
                    headers: {
                        // Override or delete Content-Type - let Browser set Boundary
                        "Content-Type": undefined,
                    },
                };
            },
            // Optional: handle side effects
            //*
            async onQueryStarted(
                arg: UploadPayload,
                {
                    queryFulfilled,
                }: {
                    queryFulfilled: Promise<{
                        data: UploadResult; //FileMetadataItem; //UploadResult;
                    }>;
                },
            ) {
                try {
                    await queryFulfilled;
                    console.log(
                        `File "${arg.file.name}" uploaded successfully`,
                    );
                } catch (err) {
                    console.error("Upload failed", err);
                }
            },
            /*
			async onQueryStarted(arg, { dispatch, queryFulfilled }) {
				try {
					await queryFulfilled;
					console.log(`File "${arg.file.name}" uploaded successfully`);
				} catch (err) {
					console.error('Upload failed', err);
				}
			},
			// */
        }),
        fileMetadataByPage: builder.query<FileMetadataListResult, string>({
            query: (id) => `file/view/${id}`,
            async onQueryStarted(args, { dispatch, queryFulfilled }) {
                console.log("fileMetadataByPageQuery 202508301440");
                try {
                } catch (err) {
                    console.log("");
                }
            },
        }),
        byFilter: builder.query<FileMetadataListResult, Filter>({
            query: (f) => `file/by-filter/?${filterToQueryString(f)}`,
            async onQueryStarted(args, { dispatch, queryFulfilled }) {
                console.log("fileMetadataByPageQuery 202508301440");
                try {
                    await queryFulfilled;
                } catch (err) {
                    console.log("");
                }
            },
        }),
        fileEdit: builder.mutation<
            FileMetadataEditResponse,
            FileMetadataEditRequest
        >({
            query: (body) => {
                const idStr = body.metadata.id ? "/" + body.metadata.id : "";
                return {
                    url: "/file/edit" + idStr,
                    method: "POST",
                    body,
                };
            },
            invalidatesTags: [],
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled;
                    if (data.file) {
                        dispatch(upsertFile(data.file));
                    }
                } catch (err) {
                    console.log("202411301427: edit ticket api error", err);
                }
            },
        }),
    }),
});

export const {
    useFileViewQuery,
    useUploadFileMutation,
    useFileMetadataByPageQuery,
    useByFilterQuery,
    useFileEditMutation,
} = fileApi;
